import { Modal, ModalProps } from '@/components/modal'

export const ResubscribePlayerOnMobileModal = (props: ModalProps): JSX.Element => {
  return (
    <Modal
      customStyles={{
        content: {
          padding: '48px 35px',
          width: '600px',
        },
      }}
      {...props}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        利用プランの再開
      </h3>
      <div>
        <div className="mt-4 px-4 pb-[21px] text-center text-[15px] text-secondary-text">
          <p>利用プランの再開は、学習者アプリからご対応いただけます。</p>
        </div>
      </div>
    </Modal>
  )
}
